export default {
  props: {
    data: {
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
